export function getFirstName (fullName) {
if(!fullName) return fullName
  const [firstName] = fullName.split(' ')
  const formatted = firstName.charAt(0).toUpperCase() + firstName.slice(1);
   return formatted
}

export function formatName(name) {
    if(!name) return name
    return name
        .split(' ') // Split the name into parts
        .map(part => {
            // Check if the name part is hyphenated
            if (part.includes('-')) {
                return part
                    .split('-')
                    .map(subPart => subPart.charAt(0).toUpperCase() + subPart.slice(1).toLowerCase())
                    .join('-'); // Capitalize both parts of the hyphenated name
            }
            // Capitalize the first letter of each part and lowercase the rest
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        })
        .join(' '); // Join the name back into a string
}